module.exports = __webpack_public_path__ + "img/iatilogo.f12453f8.png";